module.exports = __webpack_public_path__ + "img/bg_avatar_male_88.4092f780.png";